import React from 'react'

const Mentors = () => {
    return (
        <>
            <h1>
                Mentors
            </h1>
        </>
    )
}

export default Mentors
